export default "__VITE_ASSET__BhhBMYVC__"